import React, { FunctionComponent, useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Grid, Box } from "@material-ui/core";
import { useResyncConfStyles } from "./useResyncConfStyles";
import { ResyncConfTables } from "./ResyncConfTablesView/ResyncConfTables";
import { useStore } from "../../store";
import { ResyncConfTablesList } from "./ResyncConfTablesView/ResyncConfTablesList";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
export const ResyncConfTablesMaster = () => {
  const [user] = useStore("auth", "user");
  const [
    viewResyncConfTablesPermission,
    setViewResyncConfTablesPermission,
  ] = useState<boolean>(false);
  const [
    editResyncConfTablesPermission,
    setEditResyncConfTablesPermission,
  ] = useState<boolean>(false);
  const [
    addResyncConfTablesPermission,
    setAddResyncConfTablesPermission,
  ] = useState<boolean>(false);
  const [value, setValue] = React.useState(0);
  const classes = useResyncConfStyles();

  const [services] = useStore("service");
  useEffect(() => {
    const resyncPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 24
    );

    if (user.is_super_admin === true) {
      setAddResyncConfTablesPermission(true);
      setViewResyncConfTablesPermission(true);
      setEditResyncConfTablesPermission(true);
    } else {
      if (resyncPermission) {
        if (resyncPermission.is_add === true) {
          setAddResyncConfTablesPermission(true);
        }
        if (resyncPermission.is_view === true) {
          setViewResyncConfTablesPermission(true);
        }
        if (resyncPermission.is_edit === true) {
          setEditResyncConfTablesPermission(true);
        }
      }
    }
  });
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Helmet>
        <title>Reconfigure tables</title>
      </Helmet>
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label="Configuration List"
              style={{ display: viewResyncConfTablesPermission ? "" : "none" }}
            />
            <Tab
              label="Edit Configurations"
              style={{ display: editResyncConfTablesPermission ? "" : "none" }}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={12}>
              <ResyncConfTablesList serviceList={services} />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={12}>
              <ResyncConfTables serviceList={services} />
            </Grid>
          </Grid>
        </TabPanel>
      </div>
    </>
  );
};
